import { compose, withState } from 'recompose'
import ManageProfileList from '../../components/profiles/profiles-manage-list'

const enhance = compose(
  withState('currentActiveEdit', 'setCurrentActiveEdit', null)
)

export default enhance(ManageProfileList)
